export default "__VITE_ASSET__dd4f6f81__"